<template>
  <section class="sec">
    <div class="col">
      <div class="sec-cab sec-cab--centro">
        <span class="tag">O que transportamos</span>
        <h2 class="sec-h2">Um tipo de frete para cada operação</h2>
        <p class="sec-p">
          Carga fracionada, dedicada ou em roteiro fixo na Grande São Paulo — e produto
          perigoso quando o embarque exige veículo e motorista habilitados para isso.
        </p>
      </div>

      <div class="grade">
        <article
          v-for="(s, i) in SERVICOS"
          :key="s.cod"
          class="cartao cartao--sobe card revela"
          :style="{ transitionDelay: (i * 0.08) + 's' }"
          v-revela
        >
          <div class="foto">
            <img :src="fotos[i % fotos.length]" alt="" loading="lazy" />
            <h3>{{ s.titulo }}</h3>
          </div>
          <div class="corpo">
            <p>{{ s.desc }}</p>
            <ul>
              <li v-for="t in s.itens" :key="t">{{ t }}</li>
            </ul>
            <router-link to="/solicitar" class="mais">Pedir este frete <span>→</span></router-link>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup>
import { SERVICOS } from '@/config/operacao'

const fotos = [
  require('@/assets/img/carga.jpg'),
  require('@/assets/img/rodovia.jpg'),
  require('@/assets/img/motion.jpg'),
  require('@/assets/img/hero-estrada.jpg'),
]
</script>

<style scoped>
.grade { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }
.card { overflow: hidden; display: flex; flex-direction: column; }

.foto { position: relative; height: 152px; overflow: hidden; flex-shrink: 0; }
.foto img {
  width: 100%; height: 100%; object-fit: cover;
  transition: transform .55s var(--ease);
}
.card:hover .foto img { transform: scale(1.07); }
.foto::after {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(180deg, transparent 42%, rgba(10, 16, 24, .78));
}
.foto h3 {
  position: absolute; left: 16px; right: 16px; bottom: 13px; z-index: 2;
  color: #fff; font-size: 17px; font-weight: 800; letter-spacing: -.03em;
}

.corpo { padding: 18px 20px 22px; display: flex; flex-direction: column; flex: 1; }
.corpo p { font-size: 14px; line-height: 1.6; color: var(--texto); }

ul { list-style: none; padding: 0; margin: 14px 0 0; }
li {
  position: relative;
  padding: 5px 0 5px 17px;
  font-size: 12.5px;
  color: var(--texto-fraco);
}
li::before {
  content: ''; position: absolute; left: 0; top: 12px;
  width: 7px; height: 7px; border-radius: 50%;
  background: var(--azul-fundo); border: 1.5px solid var(--azul);
}

.mais {
  display: inline-flex; align-items: center; gap: 7px;
  margin-top: auto; padding-top: 16px;
  color: var(--azul-esc); font-weight: 700; font-size: 13.5px; text-decoration: none;
}
.mais span { transition: transform .25s var(--ease); }
.card:hover .mais span { transform: translateX(4px); }

@media (max-width: 1100px) { .grade { grid-template-columns: 1fr 1fr; } }
@media (max-width: 620px) { .grade { grid-template-columns: 1fr; } }
</style>
